import { productPriceStyles as styles } from "@insite/content-library/Components/ProductPrice";
import { css } from "styled-components";

styles.price = {
    ...styles.price,
    realTimeText: {
        ...styles.price?.realTimeText,
        css: css`
            ${styles.price?.realTimeText?.css}
            font-size: 22px;
        `,
    },
    priceText: {
        ...styles.price?.priceText,
        css: css`
            ${styles.price?.priceText?.css}
            font-size: 22px;
        `,
    },
};
